import BottomSearch from './BottomSearch';

export default BottomSearch;
